export default __webpack_public_path__ + "static/media/ic_gmx_30.375de394.svg";